import { ocapiClient } from '../../../../../api-clients/ocapi/client';
import { convertArrayToObject } from '../../../../../utils/array-utils';
import { createFetchedDataRecord } from '../../../../../utils/fetched-data/create-fetched-data-record';
import { getCacheDuration } from '../../../../../utils/get-cache-duration';
import { loadDataFromApi } from '../../../../../utils/load-data-from-api';
import { updateObject } from '../../../../../utils/object-utils';
import { browsingDomainStore } from '../../../../browsing/store';
import { isMemberSignedIn } from '../../../selectors/member/is-member-signed-in';
import { loyaltyDomainStore } from '../../../store';
export const loadMemberWatchlistFilms = async (reloadCachedData = true) => {
    if (!isMemberSignedIn())
        throw new Error("Cannot load watchlist films when member isn't signed in.");
    const state = loyaltyDomainStore.data.memberWatchlistFilmsById;
    await loadDataFromApi({
        api: ocapiClient.instance.v1.loyalty.members.watchlistFilms.getAll,
        state,
        cacheDuration: getCacheDuration('member'),
        reloadCachedData,
        onSuccess
    });
};
const onSuccess = (response, cacheDuration) => {
    const { films, relatedData } = response;
    assignRelatedData(relatedData, cacheDuration);
    return convertArrayToObject(films, 'filmId');
};
const assignRelatedData = (relatedData, cacheDuration) => {
    const { castAndCrew, censorRatings, films, genres } = relatedData;
    const { data } = browsingDomainStore;
    updateObject(data.filmsById, createFetchedDataRecord(films, 'id', cacheDuration));
    updateObject(data.castAndCrewMembersById, createFetchedDataRecord(castAndCrew, 'id', cacheDuration));
    updateObject(data.censorRatingsById, createFetchedDataRecord(censorRatings, 'id', cacheDuration));
    updateObject(data.genresById, createFetchedDataRecord(genres, 'id', cacheDuration));
};
